import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fdaaf2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "welfare-container" }
const _hoisted_2 = { class: "left animate__zoomIn wow" }
const _hoisted_3 = { class: "right animate__zoomIn wow" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "little-circles1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "little-circle1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "little-circle2" })
], -1))
const _hoisted_5 = { class: "center-circles" }
const _hoisted_6 = { class: "first-circle commom-circle" }
const _hoisted_7 = { class: "title-span" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "little-circles3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "little-circle3" }),
  /*#__PURE__*/_createElementVNode("div", { class: "little-circle4" }),
  /*#__PURE__*/_createElementVNode("div", { class: "little-circle5" })
], -1))
const _hoisted_9 = { class: "second-circle commom-circle" }
const _hoisted_10 = { class: "title-span" }
const _hoisted_11 = { class: "third-circle commom-circle" }
const _hoisted_12 = { class: "title-span" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "little-circles2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "little-circle4" }),
  /*#__PURE__*/_createElementVNode("div", { class: "little-circle3" })
], -1))

import WOW from 'wowjs'
import { onMounted, ref } from "vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'welfareView',
  setup(__props) {

onMounted(() => {
  new WOW.WOW(
    { live: false }
  ).init()

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('weltitle')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('welhere')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('welsalary')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('welsalarytext2')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('welsalarytext3')), 1)
        ]),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('welmedal')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('wemedalext1')), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('welvalue')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('welvaluetext1')), 1)
        ]),
        _hoisted_13
      ])
    ])
  ]))
}
}

})